import { DurationValue } from '../../data-objects'
import { FieldDefinition } from './field-definition'

export class DurationFieldDefinition extends FieldDefinition {
  public format: string

  constructor(el: DurationFieldDefinition) {
    super(el)
    this.format = el.format
  }

  public getFieldValue() {
    const toReturn = new DurationValue()
    return toReturn
  }
}
